"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Runtime", {
    enumerable: true,
    get: function() {
        return Runtime;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _jsxruntime = /*#__PURE__*/ _interop_require_wildcard._(require("react/jsx-runtime"));
const Runtime = _jsxruntime;
